/**
 * Configuration for resume info. Provides information
 * on resume fields and mapping between API names and drupal naming structure.
 */
/* tslint:disable */

// Feature flags.
const RESUME_FEATURES = {
  RESUME_IMPORT_FEATURE_ACTIVE: true,
  RESUME_FEATURE_ACTIVE: true,
  APPLICANT_FEATURE_ACTIVE: true,
  RESUME_TOPCV_FEATURE_ACTIVE: false,
  RESUME_TOPCV_UPLOAD_CHECKED: false,
  RESUME_BADGES_ACTIVE: false,
};

module.exports = {
  public: {
    RESUME_IMPORT_FEATURE_ACTIVE: RESUME_FEATURES.RESUME_IMPORT_FEATURE_ACTIVE,
    RESUME_FEATURE_ACTIVE: RESUME_FEATURES.RESUME_FEATURE_ACTIVE,
    RESUME_CONTACT_SETTINGS: {
      ALLOW_REVOKE: true,
    },
    RESUME_DETAIL_SHOW_EMAIL: false,
    APPLICANT_FEATURE_ACTIVE: RESUME_FEATURES.APPLICANT_FEATURE_ACTIVE,
    RESUME_TOPCV_FEATURE_ACTIVE: RESUME_FEATURES.RESUME_TOPCV_FEATURE_ACTIVE,
    RESUME_BADGES_ACTIVE: RESUME_FEATURES.RESUME_BADGES_ACTIVE,
    RESUME_SEARCH_PAGE: '/resumes',
    RESUME_SEARCH_LISTING_NUMBER: 10,
    INCOMPLETE_REDIRECT_TO_WIZARD: false,
    RESUME_DASHBOARD_SHOW_APPLICATIONS: true,
    FACETS: [
      {
        title: 'Career status',
        fieldName: 'field_resume_career_status',
        multiple: true,
        operator: 'OR',
      },
      {
        title: 'Languages',
        fieldName: 'field_resume_languages',
        multiple: true,
        operator: 'OR',
      },
      {
        title: 'Skills',
        fieldName: 'field_resume_skills_parents_all',
        multiple: true,
        operator: 'OR',
      },
      {
        title: 'Occupations',
        fieldName: 'field_resume_job_pref_occupation',
        multiple: true,
        operator: 'OR',
      },
      {
        title: 'Region',
        fieldName: 'resume_region_facet',
        multiple: true,
        operator: 'OR',
      },
      {
        title: 'Field of study',
        fieldName:
          'field_resume_edu_field_resume_edu_field_of_study_parents_all',
        multiple: true,
        operator: 'OR',
      },
    ],
    RESUME_CONTACT_FILTERS: {
      resume_contact_pending: {
        name: 'Pending',
        code: 'pending',
      },
      resume_contact_approved: {
        name: 'Approved',
        code: 'approved',
      },
    },
    RESUME_CONTACT_CREDITS_PAGE: 'contact',
    FIELD_INFO: {
      personal_info: {
        key: 'personal_info',
        name: 'Enter your personal information',
        description: `Add your personal data to your profile.`,
        validatePrivateFields: true,
        privateFields: {
          resume_firstname: true,
          resume_lastname: true,
          field_resume_phone: true,
          field_resume_birthday: true,
          field_resume_home_location: true,
        },
        fields: {
          field_resume_salutation: 'salutation',
          field_resume_photo: 'picture',
          resume_firstname: 'firstName',
          resume_lastname: 'lastName',
          field_resume_phone: 'phone',
          field_resume_birthday: 'birthday',
          field_resume_home_location: 'homeLocation',
          field_resume_about_me: 'about',
        },
      },
      job_preferences: {
        key: 'job_preferences',
        name: 'Enter your Job preferences',
        description: `Provide the recruiters more information about your job preferences.`,
        fields: {
          field_resume_title: 'title',
          field_resume_job_pref_occupation: 'desiredOccupation',
          field_resume_employment_type: 'employmentType',
          field_resume_pref_location: 'desiredLocation',
          field_resume_pref_salary_range: 'desiredSalary',
          field_resume_career_status: 'careerStatus',
          field_resume_job_availability: 'availableStart',
          field_resume_availability_period: 'availabilityPeriods',
        },
      },
      education: {
        key: 'education',
        name: 'Education Information',
        description: `Let the recruiters know about your education.`,
        fields: {
          id: 'id',
          field_resume_edu_institution: 'institution',
          field_resume_edu_degree_level: 'degreeLevel',
          field_resume_edu_field_of_study: 'fieldOfStudy',
          field_resume_edu_study_program: 'studyProgram',
          field_resume_edu_location: 'location',
          field_resume_edu_time_period: 'timePeriod',
          field_resume_edu_summary: 'summary',
        },
      },
      work_experience: {
        key: 'work_experience',
        name: 'Work experience Information',
        description: `Put in detailed information about your previous work experiences.`,
        fields: {
          id: 'id',
          field_resume_xp_job_title: 'jobTitle',
          field_resume_xp_occupation_field: 'occupation',
          field_resume_xp_employment_type: 'employmentType',
          field_resume_xp_company: 'companyName',
          field_resume_xp_location: 'location',
          field_resume_xp_time_period: 'timePeriod',
          field_resume_xp_summary: 'summary',
        },
      },
      languages: {
        key: 'languages',
        name: 'Languages information',
        description: `Add information about spoken language and the level you're in.`,
        fields: {
          field_resume_languages: 'languages',
          field_resume_languages_free: 'languagesFree',
          field_resume_languages_notes: 'languageNotes',
        },
      },
      skills: {
        key: 'skills',
        name: 'Skills information',
        description: `Let the recruiters know about your skills.`,
        fields: {
          field_resume_skills: 'skills',
          field_resume_skills_free: 'skillsFree',
          field_resume_skills_notes: 'skillsNotes',
        },
      },
      badges: {
        key: 'badges',
        name: 'Badges information',
        description: `Show off your badges and certifications to the recruiters.`,
        fields: {},
      },
    },
    RESUME_SECTIONS_TO_HIDE: [],
    RESUME_ATTACHMENTS_BOX_ACTIVE: true,
    RESUME_PERCENTAGE_BOX_ACTIVE: true,
    RESUME_COMPLETENESS_CARD_ACTIVE: true,
    LAYOUT: {
      sideBarBoxColor: 'white',
      DETAIL: {
        BOX_TEXT_COLOR: 'gray5',
        SHOW_ICONS: true,
      },
    },
    WIZARD_HIDDEN_FIELDS: {
      personal_info: [
        'field_resume_photo',
        'field_resume_about_me',
        'field_resume_phone',
      ],
      job_preferences: ['field_resume_phone'],
    },
    REGISTER: {
      register_applicant: {
        key: 'register_applicant_form',
        fields: {},
      },
    },
    HIDE_GEO_SEARCH: false,
    HIDE_KEYWORD_SEARCH: false,
    GEO_INFO: {
      radius: {
        options: [5, 25, 50, 100, 200],
        defaultValue: 100,
        unit: 'km',
        unitMultiplier: 1,
        hideForLocationType: [
          'country',
          'administrative_area_level_1',
          'administrative_area_level_2',
          'administrative_area_level_3',
        ],
      },
      types: ['(regions)'],
      fixtures: null,
    },
    RESUME_ALERT: {
      ignoreFields: [],
      form: {
        notifyIntervalValues: [
          {
            code: '-1',
            name: 'No alerts for new matches',
          },
          {
            code: '86400',
            name: 'Daily',
          },
          {
            code: '604800',
            name: 'Weekly',
          },
          {
            code: '2628000',
            name: 'Monthly',
          },
        ],
      },
    },
    FIELDS_OF_STUDY_FEATURE_ACTIVE: false,
    DISABLE_GRADUATION_ICON: false,
    FLAGGED_FIELDS: [
      {
        FIELDS_OF_STUDY_FEATURE_ACTIVE: {
          form: {
            groupKey: 'education',
            fieldName: 'field_resume_edu_field_of_study',
          },
          facet: {
            fieldName:
              'field_resume_edu_field_resume_edu_field_of_study_parents_all',
          },
        },
      },
    ],
    WIDGET_ADD_BUTTON_DISABLED_LIST: [],
    WIDGET_EDIT_BUTTON_DISABLED_LIST: [],
    TOGGLE_RESUME_VISIBILITY: true,
  },
  server: {},
};
